const article = {
  slug: 'getting-started',
  title: 'Getting around',
  section: 'Basics',
  body: `
# Getting around

The sidebar is organized around the daily loop: **Dashboard** for today's
picture, **Customers / Units / Rentals** for the roster, **Payments /
Invoices** for money, **Reports** for analysis, and **Settings** for
configuration (automation, fees, lease templates, team, integrations).

## Quick tools

- Press **Cmd/Ctrl + K** for the command palette - jump to any page or record.
- The **?** icon in the header opens this help center from anywhere.
- Most list pages support search, status filters, CSV export, and pagination.

## The one rule that explains most behavior

Automation follows the tenant lifecycle: **Account -> Sign lease -> Pay ->
Gate code -> Active.** Each step gates the next - for example, a tenant
who signed but hasn't paid does NOT get a gate code email yet. If an
email "didn't fire," check which gate the tenant is stuck behind first.
`,
};

export default article;
